import React, { useState } from 'react';
import { FaUserShield, FaUserClock, FaUsers } from 'react-icons/fa';
import PendingApprovals from './components/PendingApprovals';
import UserManagement from './components/UserManagement';
import { initialUsers } from './data/users';
import './SuperAdmin.css';

function SuperAdmin() {
  const [activeTab, setActiveTab] = useState('pending');
  const [users, setUsers] = useState(initialUsers);

  const handleApproval = (userId) => {
    setUsers(users.map(user => 
      user.id === userId ? { ...user, status: 'approved' } : user
    ));
  };

  const handlePermissionUpdate = (userId, permissions) => {
    setUsers(users.map(user => 
      user.id === userId ? { ...user, permissions } : user
    ));
  };

  const handleUserUpdate = (userId, updates) => {
    setUsers(users.map(user => 
      user.id === userId ? { ...user, ...updates } : user
    ));
  };

  const handleUserDelete = (userId) => {
    setUsers(users.filter(user => user.id !== userId));
  };

  return (
    <div className="super-admin-container">
      <header className="super-admin-header">
        <h1><FaUserShield className="header-icon" /> Super Admin Dashboard</h1>
        <nav className="super-admin-nav">
          <button 
            className={`super-admin-tab ${activeTab === 'pending' ? 'active' : ''}`}
            onClick={() => setActiveTab('pending')}
          >
            <FaUserClock className="tab-icon" /> Pending Approvals
          </button>
          <button 
            className={`super-admin-tab ${activeTab === 'management' ? 'active' : ''}`}
            onClick={() => setActiveTab('management')}
          >
            <FaUsers className="tab-icon" /> User Management
          </button>
        </nav>
      </header>

      <main className="super-admin-main">
        {activeTab === 'pending' ? (
          <PendingApprovals 
            users={users.filter(user => user.status === 'pending')}
            onApprove={handleApproval}
          />
        ) : (
          <UserManagement 
            users={users.filter(user => user.status === 'approved')}
            onUpdatePermissions={handlePermissionUpdate}
            onUpdateUser={handleUserUpdate}
            onDeleteUser={handleUserDelete}
          />
        )}
      </main>
    </div>
  );
}

export default SuperAdmin;